import React from "react"
import {translationKeys} from "../../../localizations/translationKeys-localization";
import {useTranslation} from "react-i18next";
import {APP_ACTION_TYPE} from "../../reducers/appReducer";
import {useDispatch, useSelector} from "react-redux";
import ChoiceBody from "./ChoiceBody";
import MaterialTextFieldOutlinedContainer from "../../../admin/containers/MaterialTextFieldOutlinedContainer";

const AgreementBody = (props) => {
    const {t} = useTranslation()
    const formData = useSelector(state => state.appReducer.formData)
    const dispatch = useDispatch()

    const handleTermsChange = (value) => {
        const updatedFormData = {...formData}
        updatedFormData.pages[0].questions[props.index].terms_and_conditions = value
        dispatch({type: APP_ACTION_TYPE.SET_FORM_DATA, payload: updatedFormData})
    }

    return (
        <>
            <div className={"agreement-terms"} style={{height: "150px", margin: "10px", marginBottom: "40px"}}>
                <MaterialTextFieldOutlinedContainer placeHolder={t(translationKeys.terms_and_conditions)}
                                                    defaultValue={props.question.terms_and_conditions}
                                                    maxLength={10000}
                                                    onChange={handleTermsChange}
                                                    validationFunction={(value) => value?.length > 0}
                                                    errorText={'Terms & Conditions are Required'}
                                                    customStyleObject={{
                                                        height: "150px",
                                                        backgroundColor: "#F5F5F5"
                                                    }}
                                                    textArea={true}
                />
                <div className={"mdc-text-field-character-counter"} style={{textAlign: "end"}}>
                    {(props.question?.terms_and_conditions?.length ? props.question.terms_and_conditions.length : 0)} / 10000
                </div>
            </div>
            <ChoiceBody {...props}/>
        </>
    )
}

export default AgreementBody
